var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlKidsPlaygroundFilled = function SvgHtlKidsPlaygroundFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.203 12.873-.068-.12a2.171 2.171 0 0 1-.14-.298l-.062-.169a1.377 1.377 0 0 0-1.25-.9 1.378 1.378 0 0 0-.918.31l-.3.243a.501.501 0 1 1-.63-.778l.3-.243a2.41 2.41 0 0 1 1.582-.531c.314.01.622.083.907.213a2.368 2.368 0 0 1 1.246 1.34l.064.168c.02.054.044.106.072.156l.069.122a1.025 1.025 0 0 0 1.052.518 1.026 1.026 0 0 0 .862-.78L5.175 6.76a1.073 1.073 0 0 1 .227-1.29L8.73 2.438a1.07 1.07 0 0 1 1.56.118l2.998 3.707a1.074 1.074 0 0 1-.049 1.408l-4.262 4.587a.512.512 0 0 1-.008.084 2.031 2.031 0 0 1-1.7 1.557 2.031 2.031 0 0 1-2.066-1.026Z"
  })));
};
export default SvgHtlKidsPlaygroundFilled;